export default __webpack_public_path__ + "static/media/spring.c5203fb3.png";